<template>
  <picture>
    <source
      v-for="(source, index) in props.mediaImageSource"
      :key="index"
      :srcset="source.srcset"
      :media="source.media"
      :type="source.type"
      :width="source.width"
      :height="source.height"
    />
    <img
      :src="props.mediaImageUrl"
      :alt="props.mediaImageAlt"
      :title="props.mediaImageTitle || undefined"
      :width="props.mediaImageWidth ? Number(props.mediaImageWidth) : undefined"
      :height="props.mediaImageHeight ? Number(props.mediaImageHeight) : undefined"
      fetchpriority="auto"
      class="w-auto aspect-auto h-auto"
    />
  </picture>
</template>

<script setup lang="ts">
import type { ResponsiveImage } from '~/types'

defineOptions({
  inheritAttrs: false
})

const props = defineProps<Omit<ResponsiveImage, 'mediaImageWidth' | 'mediaImageHeight'> & {
  mediaImageWidth?: number | string
  mediaImageHeight?: number | string
}>()
</script>